export default "__VITE_ASSET__BvR8_BzS__"